const tw = {
  updateInfo: "更新資訊",
  updateHouseInfo: '3D模型屋升級通知',
  hurryUp: '快點確認',
  message: {
    saveSuccess: "保存成功",
    saveFail: "保存失敗",
    updateSuccess: "修改成功",
    deleteSuccess: "刪除成功",
    deleteFail: "刪除失敗",
    deleteLoading: "刪除中",
    regainSuccess: "恢復成功",
    selectPath: "請先選擇目錄",
    nameErr: "請輸入帳號",
    phoneErr: "請輸入手機號碼",
    codeErr: "請輸入驗證碼",
    sendCode: "發送驗證碼",
    pwdErr: "請輸入密碼",
    reInputPwd: "請再次輸入密碼",
    logoutMsg0: "退出登入失敗",
    logoutMsg1: "退出登入成功",
    softDeleteHint: "您確定要刪除該條數據嗎？",
    batchSoftDeleteHint: "您確定刪除選中的一批數據嗎？",
    delUser: "您確定要刪除該用戶嗎？",
    delUserHint: "您確定要永久刪除該用戶嗎？",
    batchDelUserHint: "您確定要永久刪除選中的用戶嗎？",
    deleteHint: "您確定要永久刪除該條數據嗎？",
    batchDeleteHint: "您確定永久刪除選中的數據嗎？",
    regainHint: "您確定恢復該作品嗎？",
    regainUser: "您確定要恢復該用戶嗎？",
    reagainUserHint: "您確定要恢復選中的用戶嗎？",
    batchRegainHint: "您確定恢復選中的作品嗎？",
    selectHint: "請選擇要操作的數據行",
    copySuccess: "複製成功",
    moveSelectHint: "請選擇要移動到的目錄",
    moveSuccess: "移動成功",
    moveFail: '移動後不可超出三層資料夾',
    modifySuccess: "修改成功，請重新登入",
    waitting: "請稍等",
    finishData: "請填寫完整數據",
    noPicture: "請選擇全景圖片",
    audioFaileMessage: "您當前的瀏覽器不支持音頻播放！",
    vedioFaileMessage: "您當前的瀏覽器不支持失敗播放！",
    agentRecycleNotice:
      "經銷商放入回收站15天後，會被系統自動清理，清理後無法找回。",
    userRecycleNotice:
      "用戶放入回收站15天後，會被系統自動清理，清理後無法找回。",
    materialPreview: "素材預覽",
    workAwait: "切圖時間需要2-5分鐘",
    workAwaitFail: "上傳失敗，請刪除後重新上傳",
    loginSuccess: "登入成功",
    sendAwait: "秒後重新發送",
    registerSuccess: "註冊成功，即將進入全景",
    resetPwdSuccess: "重置成功，請登入",
    uploadBtn: "上傳",
    picture: "為全景圖片增加浮水印，建議圖片為純白色、透明背景",
    uploading: "上傳中",
    uploading2: "正在上傳，請等待",
    automaticAudit: "自動審核",
    manualAudit: "人工審核",
    openMultiCut: "開啟多層切圖",
    temporaryCloseSite: "臨時關閉站點",
    saveSettingBtn: "保存設置",
    saveSettings: "存儲設置",
    qiniuCloud: "七牛雲",
    alicloud: "阿里雲OSS",
    awscloud: "AWS",
    alicloudCommunication: "阿里雲通信",
    localStorage: "本地存儲",
    store: "存儲區",
    isIntranet: "是否內網",
    smsSettings: "短信設置",
    Newsletter: "三竹簡訊",
    isEnable: "是否啟用",
    wechatSettings: "微信設置",
    paySettings: "支付設置",
    wechatPublicPlatform: "微信公眾平臺",
    WechatOpenPlatform: "微信開放平臺",
    alipay: "企業支付寶",
    wechatMerchants: "微信商家",
    ecpay: "綠界支付",
    uploadPanoImage: "上傳全景圖片",
    memberRenew: "會員續費",
    replacePanoImage: "替換全景圖片",
    allow: "允許",
    appSettings: "app設置",
    lineSettings: "line設置",
    unallowed: "不允許",
    storageTypeMessage: "請選擇擴充的容量",
    childLimitTips: "最多可建立帳號數",
    userCapaityTips: "每個帳號空間大小",
    collapseOpen: "展開",
    collapseClose: "關閉",
    deleteAccount: "刪除帳號",
    bulkDelete: "批量刪除",
    previewPanoImage: "全景素材預覽",
    delMaterialAll: "確認刪除",
    delMaterialAllCheck: "確認要刪除未使用的素材？",
    workRecycleNotice:
      "作品放入回收站15天後，會被系統自動清理，清理後無法找回。",
    newFolderError: "文件夾名稱不能為空！",
    moveToPopupTitle: "移動文件到",
    copyLink: "複製分享連結",
    checkInputHint: "請輸入帳號/別名進行檢索",
    phoneHint: "(作為登入全景平台帳號)",
    uploadPicErr: "未上傳圖片",
    sortTip: "請輸入排序值",
    noPower: "沒有權限",
    uploadSuccess: "上傳成功",
    nonEmpty: "必填項不能為空",
    timeOut: "登入超時, 重新登入",
    imageType: "請插入圖片類型文件(jpg/jpeg/png)",
    imageLoadFail: "圖片插入失敗",
    saving: "保存中...",
    completeMessage: "請完整填寫內容",
    workSearch: "請輸入作品名、客戶手機號",
    wrongPwd: "密碼錯誤",
    orderExtraMessage: "個月",
    singlePageMessage: "主分類為單頁面",
    offlineDownloadApp: "正在下載離線程序包...",
    offlineDownloadResource: "正在下載項目資源...",
    offlineDownloadZip: "正在生成壓縮包...",
    offlineDownloadFail: "離線下載失敗..."
  },
  common: {
    memberCenter: "個人中心",
    memberHome: "作者主頁",
    memberChange: "切換團隊",
    adminBackground: "管理後臺",
    agentBackground: "經銷商後臺",
    memberBackground: "用戶後臺",
    logout: "退出登入",
    renewAlert: "帳戶過期提示",
    renewInfo: "您的帳戶已過期，請前往",
    renewInfo2: "該用戶帳號已到期，請及時續費",
    inputContent: "請輸入內容",
    material: "素材庫",
    sceneSelect: "場景選擇",
    pano3d: "3D模型屋",
    view3d: "3D視角",
    viewPano: "全景視角",
    VR: "VR模式",
    rotate: "環景播放",
    rotateOff: "環景暫停",
    share: "作品分享",
    briefInfo: "作品簡介",
    avatar: "頭像",
    hasSelect: "已選擇",
    selectedUnit: "項",
    homepage: "官網",
    inputHolder: "請輸入",
    vrname: "全景名稱",
  },
  actionTitles: {
    download: "下載",
    replace: "替換",
    addRegion: "新增區域",
    timeOrder: "按時間",
    viewsOrder: "瀏覽量",
    selectAll: "全選",
    clearAll: "清空選擇",
    submitModify: "提交修改",
    confirmModify: "確認修改",
    enableModify: "允許修改",
    cancel: "取消",
    submit: "提交",
    rename: "重新命名",
    save: "保存",
    delete: "刪除",
    resume: "恢復",
    edit: "編輯",
    editing: "編輯機位",
    confirm: "確認",
    ascertain: "確定",
    avatarUpload: "上傳頭貼",
    moveTo: "移動",
    offlineDownload: "離線下載",
    add: "新增",
    yes: "是",
    no: "否",
    share: "分享",
    workUpgrade: "3D升級",
    copy: "複製作品",
    newFolder: "新建文件夾",
    batchOperate: "批量操作",
    moreOperate: "更多操作",
    back: "返回",
    search: "搜尋",
    reset: "重置",
    clear: "清空",
    audit: "審核",
    uploadMaterial: "上傳素材",
    delMaterialAll: "一鍵刪除未使用素材",
    addseats: "增加機位",
    gourl: "直播地址：",
    backurl: "回放地址：",
    renew: "續費",
    create: "新建",
    refuse: "駁回",
    approved: "通過",
    detail: "詳情",
    config: "配置",
    viewWork: "查看作品",
    ViewSubAccount: "查看子帳帳戶",
    preview: "預覽",
    setAngle: "將眼前畫面設為開始視角",
    addGroups: "增加分組",
    publish: "發佈",
    finish: "完成",
    prev: "上一步",
    next: "下一步",
    changeCover: "更換",
    uploadConfirm: "確定上傳",
    payConfirm: "確認付款",
    refresh: "刷新",
    clickHere: "點擊這裡",
    addChildCate: "添加子分類",
    modify: "修改",
    talk: "說一說",
    applyAll: "應用全部",
    applyNew: "應用新增",
    sceneClassification: "場景歸入",
    uploadePanramic: "上傳全景影片",
    designate: "指派",
    selectUser: "選擇人員",
    tongPing: '對比圖',
    surePurchase: '確定購買',
  },
  moduleTitles: {
    customerList: "客戶管理",
    customer: "客戶管理",
    pclive: "全景直播",
    roampublish: "創建作品",
    home: "首頁",
    vrWorks: "全景作品",
    creater: "創作者",
    vrinfo: "全景資訊",
    allInfo: "全部資訊",
    workAuthor: "全景作者",
    selectedWork: "精選作品",
    recentlyWork: "最近更新",
    newWork: "最新作品",
    newWork2: "最新收錄",
    hotWork: "最熱作品",
    pcpublish: "全景發佈",
    dashboard: "信息總覽",
    sysManage: "系統管理",
    siteManage: "站點設置",
    cateManage: "分類設置",
    tagManage: "標籤管理",
    advManage: "廣告管理",
    ArtCateManage: "文章分類",
    ArtManage: "文章管理",
    userManage: "用戶管理",
    teamManage: "團隊管理",
    agentManage: "經銷商管理",
    workManage: "作品管理",
    materialManage: "素材管理",
    materialAduit: "素材審核",
    userList: "用戶列表",
    userDetail: "用戶詳情",
    userRecycle: "用戶回收站",
    teamList: "團隊列表",
    agentList: "經銷商列表",
    agentDetail: "經銷商詳情",
    agentConfig: "經銷商配置",
    agentGeneralConfig: "通用配置",
    materialList: "素材列表",
    work: "作品",
    workList: "作品列表",
    workRecycle: "作品回收站",
    project: "專案",
    team: "團隊",
    teamMember: "團隊成員",
    teamInfo: "團隊資訊",
    projectList: "專案列表",
    materialRecycle: "素材回收站",
    allCategories: "全部分類",
    panoList: "全景圖片",
    imageList: "圖片",
    videoList: "影片",
    audioList: "音樂",
    recycle: "回收站",
    account: "帳戶",
    root: "目錄",//根目錄
    accountBasic: "帳戶基礎設置",
    accountSecure: "帳戶安全設置",

    panoramic: "全景影片 ",
    PanoramicLive: "全景直播",
    releaselive: "直播發佈",
    orderDetail: "訂單管理",
    orderDetails: "訂單詳情",
    orderInfo: "訂單信息",
    receivingInfo: "收貨信息",
    workUpgradeInfo: "升級信息",
    invoiceiInfo: "發票信息",
    material: "素材",
    userManager: "下級會員",
    accountManager: "帳戶",
    basicSetting: "基本設置",
    basicConfig: "基本配置",
    safeSetting: "密碼設置",
    userConfig: "用戶配置",
    regionManage: "地區管理",
    userSafe: "用戶回收站",
    iconManage: "圖標管理",
    payConfig: "付費規則",
    renewRule: "續費規則",
    dilatationRule: "擴容規則",
    addUser: "新增用戶",
    all: "全部",
    basicInfo: "基本資訊",
    agentSecycle: "經銷商回收站",
    myMaterial: "我的素材",
    hintMessage: "提示信息",
    employeeManage: "下級會員",
    employeeManageUserList: "用戶列表",
    employeeManageUserconfig: "用戶配置",
    employeeManageOrder: "訂單管理",
    employeeManageUserrecycle: "用戶回收站",
    memberScheme: "會員方案",
    contactUs: "聯係咨詢",
    platformUpgrade: "平臺升級",
    mealPlan: "套餐方案",
    capacityToAddValue: "容量加值",
    teamBonus: "團隊加值",
    camerasPurchased: "相機加購",
    workUpgrade: "3D升級",
    membershipPrivileges: "會員特權",
    commonProblem: "常見問題",
  },
  descriptions: {
    moneySybol: "NT$",
    recycleNotice: "放入回收站15天後，會被系統自動清理，清理後無法找回。",
    myTotalViews: "我的訪問量",
    reason: "原因",
    pwdModify: "修改密碼",
    recommendSize: "建議尺寸",
    bgm: "背景音樂",
    music: "音樂",
    speck: "背景解說",
    workViews: "作品瀏覽",
    views: "瀏覽量",
    authInfo: "作者簡介",
    aboutUs: "關於我們",
    agent: "代理加盟",
    update: "在線升級",
    support: '技術支持',
    joinUs: "加入我們",
    cTel: "合作電話",
    onlineServe: "在線客服",
    allRights: "版權所有",
    scanFollow: "掃碼關注",
    local: "所在地",
    popular: "人氣",
    briefInfo: "簡介",
    justSelect: "只看精選",
    personInfo: "個人資料",
    slogon: "全景重新記錄世界",
    slogonDesc: "優秀作品展示",
    authorRecommend: "優秀攝影師推薦",
    recommendDesc: "專業技能締造精品全景",
    accountInfo: "帳號信息",
    spaceCapacity: "空間容量",
    expire: "到期",
    profession: "專業版",
    basicVersion: "普通版",
    accountStatus: "帳號狀態",
    totalSpaceCapacity: "總空間容量",
    totalPoint: "總點數",
    selectWorkCate: "選擇作品分類",
    selectWorkIndustry: "選擇作品行業",
    selectPath: "選擇保存目錄",
    renameHeader: "輸入名稱",
    noFinish: "未完整填寫",
    autoRotate: "自動旋轉",
    introduce: "簡介",
    modelHouse: "3D 模型屋升級",
  },
  login: {
    memberLogin: "會員登入",
    freeRegister: "免費註冊",
    userRegister: "用戶註冊",
    toLogin: "去登錄",
    toRegister: "去註冊",
    password: "密碼",
    login: "登 入",
    register: "註冊",
    resetPassword: "重置密碼",
    forgetPwd: "忘記密碼",
    noAccount: "還沒有帳號",
    hasAccount: "已有帳號",
    findPassword: "找回密碼",
  },
  upload: {
    cutImage: "裁剪圖片",
    waitUpload: "等待上傳",
    imageSizeInfo: "必須是2:1的全景圖",
    fileSizeLimit: "文件不能超過",
    searchHolder: "請輸入素材名搜尋",
    message: {
      vr: "全景素材上傳中，請耐心等待...",
      pic: "圖片素材上傳中，請等待...",
      audio: "音頻素材上傳中，請等待...",
      video: "影片素材上傳中，請等待",
    },
  },
  publish: {
    addMer: "從素材庫選擇",
    addPanoramic: "從素材庫選擇全景影片",
    addlive: "從素材庫選擇直播機位",
    addDes: "點擊或將文件拖拽到這裡上傳",
    addDesL: "請上傳2:1全景圖僅支持JPG、JPEG格式, 大小不超過200MB",
    publishNoSelectedMessage: "未選擇全景圖或全景影片",
    addTongPing: "從場景列表選擇對比圖場景",
    workName: {
      label: "作品名稱",
      placeholder: "輸入作品名稱",
      message: "作品名稱不能為空",
    },
    industry: {
      label: "作品行業",
      placeholder: "請選擇作品行業",
      message: "作品行業不能為空",
    },
    customerName: {
      label: "客戶姓名",
      placeholder: "請輸入客戶姓名",
      message: "客戶姓名不能為空",
    },
    customerTel: {
      label: "客戶電話",
      placeholder: "請輸入客戶電話",
      message: "客戶電話不能為空",
    },
    workTag: {
      label: "作品標籤",
      placeholder: "請選擇作品標籤",
      message: "請選擇作品標籤",
    },
    workCategory: {
      label: "作品分類",
      placeholder: "請選擇作品分類",
      message: "請選擇作品分類",
    },
    starttime: {
      label: "開始時間",
      placeholder: "請選擇直播開始時間",
      message: "直播開始時間不能為空",
    },
    endtime: {
      label: "結束時間",
      placeholder: "請選擇直播結束時間",
      message: "直播結束時間不能為空",
    },
    workRegion: {
      label: "作品地區",
      placeholder: "請選擇作品地區",
      message: "請選擇作品地區",
    },
    savePath: {
      label: "保存位置",
      placeholder: "請選擇保存位置",
      message: "請選擇保存位置",
    },
    address: {
      label: "詳細地址",
      title: "修改詳細地址",
      placeholder: "請輸入詳細地址",
      message: "詳細地址不能為空",
    },
    addNewTag: {
      label: "添加標籤",
      placeholder: "請輸入標籤簽名",
      message: "添加成功",
    },
    tagAdd: "增加",
    isPublic: "是否公開",
    public: "公開",
    pravite: "保密",
    publish: "發佈全景",
    pSuccess: "發佈成功",
    pFailure: "發佈失敗",
    pDescription: "作品介紹",
    desPlaceholder: "作品描述",
    publishSuccess: "發佈成功，等待上傳完成",
  },
  edit: {
    lightRain: "小雨",
    midRain: "中雨",
    heavyRain: "大雨",
    lightSnow: "小雪",
    midSnow: "中雪",
    heavySnow: "大雪",
    stars: "下金星",
    hearts: "下愛心",
    redEnvelope: "下紅包",
    customEffect: "自定義圖片",
    sunLight: "太陽光",
    zoomIn: "放大",
    options: "操作",
    setting: "設置",
    inject: "嵌入",
    hotpoint: "熱點",
    snadbox: "平面圖",
    vrNavi: "導覽",
    special: "特效",
    openSpecial: "啟用特效",
    vrView: "視角",
    vrAutoShow: "漫遊",
    mask: "遮罩",
    ai: "AI主播",
    menu: "選單",
    name: "名稱",
    type: "類型",
    video: "影片",
    videoDetail: "影片內容",
    addMenu: "添加選單",
    picText: "圖片文本",
    companyInfo: "公司簡介",
    link: "網頁連結",
    site: "請輸入網址",
    phoneNo: "電話號碼",
    phone: "電話",
    mapAddress: "地圖地址",
    address: "地址",
    title: "標題",
    textInfo: "內容信息",
    typeList: {
      picture: "圖",
      video: "視",
      audio: "音",
      link: '超',
      scene: "場",
    },
    editMessage: {
      title: "溫馨提示",
      content: "您確定要刪除嗎？",
      content2: "預覽前請先保存修改",
      content3: "您確定要刪除所有路徑嗎？",
      prewText: "開啟新頁面預覽？",
      backContent: "退出前請記住保存哦",
      okText: "確認刪除",
      backOkText: "保存退出",
      preConfirm: "保存預覽",
      cancelText: "取消",
      backCancelText: "直接退出",
      deleteGroup: "不能刪除，作品必須至少包含一個分組.",
      deleteScene: "請至少保留一個場景",
      sceneConfirm: "請選擇場景",
      permission: "您沒有配置全景的權限",
      hotPSelect: "請選擇熱點類型",
      imageAlert: "請選擇圖片",
      iconAlert: "請選擇圖標",
      scenes: "場景",
      selectScene: "請選擇要跳轉的場景",
      injectVideoAlert: "請先選擇影片和封面",
      selectDefault: "請選擇",
      textHotpoint: "請輸入描述信息",
      imgeError: "圖片獲取失敗",
      completeInfo: "請完整填寫分組內容",
      createScene: "正在生成場景",
      noClose: "請勿刷新或關閉頁面",
      defaultMask: "使用默認遮罩",
      map: {
        title: "選中的目標點",
        placeholder: "請輸入地址搜尋",
      }
    },
    editActionTitles: {
      adsSets: "廣告設置",
      menuSets: "選單設置",
      pwdSets: "訪問密碼",
      funcSets: "功能設置",
      senceMaskSets: '場景遮罩',
      speechExplainSets: '語音解說',
      specialEffectsSetting: "特效設置",
      startAnimation: "開場動畫",
      /** 開場動畫 animation */
      startAnimationDesc: "每一個作品僅支持一種開場方式",
      startAnimationArr: ["小行星開場", "水平軌跡環繞", "小行星軌跡環繞", "水晶球開場", "小行星縮放", "無"],
      groupAction: "分組管理",
      scene: "應用到場景",
      applyglobal: "應用到全局",
      customeffects: " 自定義特效",
      sunshinepreservation: "陽光特效請切換場景分別設置保存",
    },
    angle: {
      angleRange: "視角設置",
      default: "初始",
      fovrangeMax: "最遠",
      fovrangeMin: "最近",
      vviewMax: "最高",
      vviewMin: "最低",
      hviewLeft: "最左",
      hviewRight: "最右",
      toScene: "應用視角到場景",
      fovrange: "縱深視角",
      vview: "垂直視角",
      hview: "水平視角",
      reset: "恢復默認設置",
    },
    hpInfo: {
      currentHP: "當前場景增加漫遊",
      link: "超連結",
      picture: "圖片熱點",
      video: "影片熱點",
      text: "文字熱點",
      imageText: "圖文熱點",
      audio: "音樂熱點",
      linkHP: "連結熱點",
      scenePH: "轉場漫遊",
      showTitle: "顯示標題",
      inputTitle: "請輸入標題",
      hpTitle: "熱點標題",
      hpTitleSetting: "標題設定",
      hpIconSetting: "熱點圖標設定",
      hpIcon: "請選擇熱點圖標",
      dynamicIcon: "動態圖標",
      staticIcon: "靜態圖標",
      linkSite: "輸入網頁地址",
      linkSites: "網址",
      linkSitesYT: "YouTube專用網址",
      linkSitesWarrning: "YouTube欄位已有網址",
      linkWatch: "網址",
      tooltip: "YouTube超連結如無法顯示，為此影片無法使用iframe功能",
      photos: "圖片",
      audioSelect: "選擇音樂",
      videoSelect: "選擇影片",
      videoSelect2: "選擇熱點影片",
      addHotpoint: "添加熱點",
      newpagen: "新開頁面",
      currentpage: "當前頁面",
      popup: " 彈窗",
      IconScale: "圖標大小",
      title_x: "水平軸",
      title_y: "垂直軸",
    },
    injectInfo: {
      addPaster: "添加嵌入",
      addVideo: "添加影片",
      videoCover: "影片封面",
      setCover: "設置封面",
      pasterPic: "嵌入圖片",
      pasterText: "嵌入文字",
      pasterVideo: "嵌入影片",
      selectType: "選擇要嵌入的類型",
      tinyAdjust: "細節調整",
      positionAdjust: "位置調整",
      addImage: "添加圖片",
      typeHolder: "請選擇嵌入類型",
      currentPatsers: "當前場景嵌入素材",
      addText: "添加文本標記",
      adjust: {
        xr: "繞X軸旋轉",
        yr: "繞Y軸旋轉",
        zr: "繞Z軸旋轉",
        zoom: "縮放"
      }
    },
    walk: {
      addWalk: "添加漫遊",
      addHotpoint: "添加熱點"
    },
    sandboxs: {
      selectImg: "請選擇平面圖圖片",
      selectImg2: "選擇圖片",
      sizeAlert: "請使用480X480以上尺寸的圖片",
      addMark: "添加標記",
      editMark: "編輯標記點",
      addScenes: "選擇場景並添加到平面圖中",
      addToScene: "添加到平面圖",
      noSceneToAdd: "已添加完全部的場景",
      addPoint: "添加點位",
    },
    guide: {
      pcTitle: "間隔設置",
      textGuide: "文字講解",
      audioGuide: "語音講解",
      gapTimeMob: "導覽點移動時間(秒)",
      gapTimePc: "移動間隔",
      guideTitle: "導覽",
      gap: {
        label: "間隔",
        unit: "單位",
        unitSecond: "秒",
        audio: "語音播報",
        timeHolder: "輸入間隔時間",
        textHolder: "輸入文字內容",
        textHeader: "文字內容"
      },
      guideName: {
        label: "路徑名稱",
        defaultName: "新路徑"
      },
      addGuide: "添加導覽",
      startRecord: "開始記錄",
      stopRecord: "停止記錄",
      currentGuides: "當前添加的導覽",
      deleAllGuide: "一鍵刪除",
      deleSelectedItems: "部分刪除",
    },
    input: {
      menuHolder: "請輸入選單",
      typeHolder: "選擇選單",
    },
    settings: {
      setsTitle: "全局設置",
      fullScreen: "全螢幕",
      authInfo: "作者信息",
      authName: "作者名稱",
      scrollTxt: "滾動文字",
      fixMap: "補地圖",
      fixSky: "補天空",
      companyLogo: "公司LOGO",
      companyInfo: "公司信息",
      other: "其他",
      defaultSet: "系統默認",
      singleSenceTitle: '單場設置'
    },
    form: {
      group: {
        label: "請填入分組名稱",
        title1: "填入分組名稱",
        title2: "場景歸入",
        placeholder: "請填入分組名稱",
      }
    },
    ruler: {
      ruler: "標註",
      rulerInfoNull: "無標註資訊",
      clickAddRuler: "點擊添加按鈕，進行標注添加",
      addRuler: "增加標注",
      currentSceneRuler: "現在場景中的標注",
      dragWhileEditing: "標註只能在編輯時進行拖移",
      editRuler: "編輯標註",
      long: "長度",
      longInput: "請輸入長度",
      nameInput: "請輸入標題",
      titleInput: "請填寫標題",
      unit: "單位",
      meter: "公尺",
      centimeter: "公分",
      kilometre: "公里",
      millimeter: "毫米",
      size: "尺",
      m: "m",
      cm: "cm",
      km: "km",
      mm: "mm",
      name: "標題",
      dragAdjustPosition: "拖拉兩邊圓點調整位置",
      pleaseFillTitle: "請填寫標題",
      operation: "操作",
      edit: "編輯",
      rename: "重新命名",
      delete: "刪除",
    }
  },
  tour: {
    hide: "隱藏",
    workQR: "作品QRcode",
    author: "作者",
    actionTitles: {
      pause: "暫停",
      play: "播放",
      stop: "停止",
      quickGuide: "一鍵導覽",
    },
    viewPwd: {
      title: "該作品僅允許密碼觀看",
      placeholder: "請輸入訪問密碼"
    },
    msg: {
      title: "說一說",
      placeholder: "說一說內容可聯繫作者本人進行刪除",
    },
    message: {
      videoMsg: "此影片暫無法播放，請稍後再試",
    },
    share: {
      address: "作品地址",
      circulationAddress: "作品流通地址",
      importHtml: "嵌入到網站",
      importDescription: "如嵌入後顯示異常，請在html頁面的head裏加入以下代碼",
      pcdescription1: "使用手機掃瞄QRcode",
      pcdescription2: "即刻分享妳的全景作品",
      mobdescription1: "長按保存QRcode或",
      mobdescription2: "微信右上角直接進行分享",

    }
  },
  charts: {
    totalLogin: "總登入次數",
    login: "登入次數",
    dayLogin: "日登入次數",
    totalViews: "總訪問量",
    views: "訪問量",
    dayViews: "日訪問量",
    publishTitle: "全景發佈量",
    userCre: "新增客戶",
    userPersient: "環比增加",
    release: "發佈量",
    dailyRelease: "日發佈量",
    date: "日期",
    time: "時間",
    userCount: "用戶數",
    dateRange: {
      today: "今日",
      week: "本周",
      month: "本月",
      year: "全年",
    },
    export: "導出",
    province: {
      yunnan: "雲南省",
      heilongjiang: "黑龍江省",
      guizhou: "貴州省",
      beijing: "北京市",
      hebei: "河北省",
      shanxi: "山西省",
      jilin: "吉林省",
      ningxiahuizu: "寧夏回族自治區",
      liaoning: "遼寧省",
      hainan: "海南省",
      neimenggu: "內蒙古自治區",
      tianjin: "天津市",
      xinjiang: "新疆維吾爾自治區",
      shanghai: "上海市",
      shanxisheng: "陜西省",
      gansu: "甘肅省",
      anhui: "安徽省",
      xianggang: "香港特別行政區",
      guangdong: "廣東省",
      henan: "河南省",
      hunan: "湖南省",
      jiangxi: "江西省",
      sichuan: "四川省",
      guangxi: "廣西壯族自治區",
      jiangsu: "江蘇省",
      aomen: "澳門特別行政區",
      zhejiang: "浙江省",
      shandong: "山東省",
      qinghai: "青海省",
      chongqing: "重慶市",
      fujian: "福建省",
      hubei: "湖北省",
      xizang: "西藏自治區",
      taiwan: "臺灣",
    },
  },
  model: {
    folder: {
      renameTitle: "重新命名",
      addTitle: "新建文件夾",
    },
    capacity: {
      distributionCapacityTitle: "分配容量",
    },
    renew: {
      renewTitle: "續費",
    },
    points: {
      distributePointTitle: "分配點數",
    }
  },
  form: {
    common: {
      field: {
        account: {
          label: "帳號",
          message: "請輸入帳號",
        },
        name: {
          label: "暱稱",
          title: "修改暱稱",
          message: "請輸入暱稱",
        },
        password: {
          label: "密碼",
          message: "請輸入密碼",
        },
        gender: {
          label: "性別",
          message: "請選擇性別",
          placeholder: "請選擇性別",
        },
        state: {
          label: "狀態",
          message: "請選擇狀態",
        },
        wechat: {
          label: "line",
          message: "請輸入line",
        },
        email: {
          label: "信箱",
          message: "請輸入信箱",
        },
        company: {
          label: "所屬公司",
          message: "請選擇公司",
        },
        area: {
          label: "所在地區",
          message: "請選擇地區",
        },
        address: {
          label: "街道地址",
          message: "請輸入您的詳細地址",
        },
        mobile: {
          label: "聯繫電話",
          message: "請輸入聯繫電話",
        },
        workName: {
          label: "作品名稱",
          label2: "關鍵字",
          message: "請輸入作品名稱",
          adminHolder: "作品名稱/作者帳號/經銷商",
          agentHolder: "作品名稱/作者帳號",
        },
        createFolder: {
          label: "文件夾名稱",
          placeholder: "請輸入文件夾名稱",
          message: "文件夾名稱不能為空",
        },
        phone: {
          label: "帳號",
          message: "請輸入電話",
          checkMessage: "請正確輸入電話",
        },
        materialName: {
          label: "素材名稱",
          placeholder: "請輸入素材名稱",
        },
        status: {
          label: "狀態",
          message: "請選擇狀態",
          placeholder: "請選擇狀態",
        },
        type: {
          label: "分類",
          message: "請選擇分類",
          placeholder: "請選擇分類",
        },
        refuse: {
          label: "駁回理由",
          message: "駁回理由不能為空",
          placeholder: "請輸入駁回理由",
        },
        userId: {
          label: "用戶ID",
          message: "請輸入用戶ID",
          placeholder: "請輸入用戶ID",
        },
        briefIntroduction: {
          label: "用戶簡介",
          message: "用戶簡介不能為空",
          placeholder: "請輸入用戶簡介",
        },
        expireTime: {
          label: "到期時間",
          message: "請選擇到期時間",
          placeholder: "請選擇到期時間",
        },
        userPhone: {
          label: "用戶電話",
          placeholder: "請輸入用戶電話",
        },
        keywords: {
          label: "關鍵字",
          orderHolder: "訂單號碼/用戶名/用戶帳號",
        },
        cover: {
          label: "上傳封面",
          tip: "封面支持jpg、jpeg、png等格式，500*500",
          message: "請上傳封面",
        },
        panoramic: {
          label: "上傳影片",
          tip: "全景影片一次只能上傳一個，不超過1000M",
          message: "請上傳全景影片",
          successMsg: "上傳成功"
        },
        position: {
          label: '職位',
          message: "請輸入職位"
        },
        team: {
          label: "所屬團隊",
          label2: "團隊名稱",
          placeholder: "請輸入完整的團隊名稱"
        },
        level: {
          label: "會員等級",
          placeholder: "請選擇會員等級"
        },
        waterMark: {
          label: "浮水印",
        },
        store_type: {
          label: "所屬品牌",
        },
        store_id: {
          label: "店鋪編號",
          placeholder: "請填寫店鋪編號"
        },
      },
    },
    region: {
      name: {
        label: "區域名稱",
        placeholder: "請輸入地區名稱",
        message: "請輸入地區名稱"
      },
      reginID: {
        label: "區域ID",
      },
      regionLevel: {
        label: "區域層級"
      },
      regionOption: {
        label: "查看下屬區域"
      },
      commonLabel: {
        rootRegion: "根級區域",
        currentRegion: "當前區域",
      }
    },
    cate: {
      field: {
        label: "分類名稱",
        labelParent: "父級分類",
        placeholder: "請輸入分類名稱",
      },
      modify: {
        title: "修改分類",
      },
      add: {
        title: "新增分類",
      },
    },
    article: {
      title: {
        label: "文章名稱",
        placeholder: "請輸入文章名稱",
      },
      keywords: {
        label: "關鍵字",
        placeholder: "請輸入關鍵字",
      },
      type: {
        defaultName: "主分類",
        placeholder: "類型不能為空",
      },
      modify: {
        title: "修改文章",
      },
      add: {
        title: "新增文章",
      },
      isNav: {
        label: "底部導航",
      },
      content: {
        label: "文章內容",
        placeholder: "請輸入文章內容",
      }
    },
    tag: {
      title: {
        modify: "修改標籤",
        add: "新增標籤",
      },
      name: {
        label: "標籤名稱",
        placeholder: "請輸入標籤名稱",
        message: "標籤名不能為空",
      },
      type: {
        label: "類型",
        placeholder: "請選擇類型",
        message: "標籤類型不能為空",
      },
    },
    site: {
      field: {
        siteName: {
          label: "站點名稱",
          message: "站點名稱不能為空",
          placeholder: "請輸入站點名稱",
        },
        siteKeyword: {
          label: "站點關鍵詞",
          message: "站點關鍵詞不能為空",
          placeholder: "多個關鍵詞用英文逗號隔開",
        },
        siteDesc: {
          label: "站點描述",
          message: "站點描述不能為空",
          placeholder: "請輸入站點描述",
        },
        siteLogo: {
          label: "站點logo",
        },
        waterLogo: {
          label: "浮水印logo",
        },
        enterpriseQrCode: {
          label: "企業QRcode",
        },
        ICPRecord: {
          label: "ICP備案號",
          message: "ICP備案號不能為空",
          placeholder: "請輸入ICP備案號",
        },
        companyAddress: {
          label: "公司地址",
          message: "公司地址不能為空",
          placeholder: "請輸入公司地址",
        },
        mobile: {
          label: "聯繫電話",
          message: "聯繫不能為空",
          placeholder: "請輸入聯繫電話",
        },
        qq: {
          label: "客服line",
          message: "客服line不能為空",
          placeholder: "請輸入客服line",
        },
        email: {
          label: "聯繫信箱",
          message: "聯繫信箱不能為空",
          placeholder: "請輸入聯繫信箱",
        },
        closeRegistration: {
          label: "關閉註冊",
        },
        closeSiteReason: {
          label: "關閉站點原因",
          message: "關閉站點原因不能為空",
          placeholder: "請輸入關閉站點原因",
        },
        sliceProcess: {
          label: "切圖進程數",
          message: "",
          placeholder: "請輸入切圖進程數",
        },
        panoUrl: {
          label: '首頁全景作品',
          message: '',
          placeholder: "請輸入首頁全景作品路徑",
        },
        bucket: {
          placeholder: "請輸入bucket",
        },
        accessKey: {
          placeholder: "請輸入accessKey",
        },
        secretKey: {
          placeholder: "請輸入secretKey",
        },
        accessId: {
          placeholder: "請輸入accessId",
        },
        accessSecret: {
          placeholder: "請輸入accessSecret",
        },
        appid: {
          placeholder: "請輸入appid",
        },
        appsecret: {
          placeholder: "請輸入appsecret",
        },
        clientId: {
          placeholder: "請輸入clientId",
        },
        clientSecret: {
          placeholder: "請輸入clientSecret",
        },
        redirect_uri: {
          placeholder: "請輸入redirect_uri",
        },
        cdnDomain: {
          label: "CDN域名",
          message: "CDN域名不能為空",
          placeholder: "請輸入CDN域名",
        },
        storagePath: {
          label: "存儲路徑",
          message: "存儲路徑不能為空",
          placeholder: "/結尾，相對服務器的絕對路徑，目錄須存在且可寫",
        },
        visitDomain: {
          label: "訪問域名",
          message: "訪問域名不能為空",
          placeholder: "不帶http://，結尾不加/",
        },
        smsSignature: {
          label: "短信簽名",
          message: "短信簽名不能為空",
          placeholder: "請輸入短信簽名",
        },
        templateId: {
          label: "模板ID",
          message: "模板ID不能為空",
          placeholder: "請輸入模板ID",
          extra:
            "短信模板傳參數名須為number；示例:【短信簽名】驗證碼為：${number}，15分鐘內有效",
        },
        merchantPrivateKey: {
          label: "商戶私鑰",
          message: "商戶私鑰不能為空",
          placeholder: "請輸入商戶私鑰",
        },
        alipayPublicKey: {
          label: "支付寶公鑰",
          message: "支付寶公鑰不能為空",
          placeholder: "請輸入支付寶公鑰",
        },
        merchantNumber: {
          label: "商戶號",
          message: "商戶號不能為空",
          placeholder: "請輸入商戶號",
        },
        merchantPaymentKey: {
          label: "商戶支付密鑰",
          message: "商戶支付密鑰不能為空",
          placeholder: "請輸入商戶支付密鑰",
        },
        hashKey: {
          label: "hashKey",
          message: "hashKey不能為空",
          placeholder: "請輸入hashKey"
        },
        hashIV: {
          label: "hashIV",
          message: "hashIV不能為空",
          placeholder: "請輸入hashIV"
        },
        merchantId: {
          label: "商店代號",
          message: "商店代號不能為空",
          placeholder: "請輸入hashIV"
        },
        android: {
          label: "安卓版本號",
          apk: "上傳安卓apk",
          placeholder: "安卓當前版本發",
          url: '安卓下載地址',
          aplaceholder: "安卓apk下載地址",
        },
        ios: {
          label: "iOS版本號",
          placeholder: "iOS當前版本發",
          url: ' iOS下載地址',
        },
        accessKeyId: {
          placeholder: "請輸入accessKeyId",
        },
        accessKeySecret: {
          placeholder: "請輸入accessKeySecret",
        },
      },
    },
    accountSecure: {
      field: {
        orginPassword: {
          label: "原始密碼",
          message: "原始密碼不能為空",
          placeholder: "當前帳戶的密碼",
        },
        newPassword: {
          label: "新密碼",
          message: "新密碼不能為空",
          placeholder: "要設置的新密碼",
          lengthMessage: "密碼長度不能低於6",
        },
        confirmPassword: {
          label: "確認密碼",
          message: "新密碼不能為空",
          inconformityMessage: "兩次密碼不一致",
          placeholder: "再次確認新密碼",
        },
      },
    },
    work: {
      field: {
        name: {
          label: "作品名稱",
          message: "作品名稱不能為空",
          placeholder: "請輸入作品名稱",
        },
      },
    },
    folder: {
      field: {
        name: {
          lable: "文件夾名稱",
          message: "文件夾名稱不能為空",
          placeholder: "請輸入文件夾名稱",
        },
      },
    },
    userDetail: {
      accountStatus: {
        account: "登入帳號",
        subAccount: "子帳號",
        staffAccount: "員工帳號",
        motherAccount: "母帳號",
        edition: "專業版",
        expire: "到期",
      },
      spaceCapacity: {
        increaseCapacity: "增加容量",
        setCapacity: "分配容量",
        existingAccount: "已建帳號",
        existingAccountUnit: "個",
      },
      setPoint: '分配點數',
      form: {
        field: {
          mobile: {
            label: "聯繫電話：（作為登入全景平臺的帳號）",
            placeholder: "請輸入聯繫電話",
            message: "聯繫電話不能為空",
            userId: "用戶ID",
          },
          contact: {
            label: "聯繫人",
            placeholder: "請輸入聯繫人",
            message: "聯繫人不能為空",
          },
          company: {
            label: "公司名稱",
            placeholder: "請輸入公司名稱",
            message: "公司名稱不能為空",
          },
          region: {
            label: "所在區域",
            placeholder: "請選擇區域",
            message: "區域不能為空",
          },
          address: {
            label: "詳細地址",
            placeholder: "請輸入詳細地址",
            message: "地址不能為空",
          },
          wechat: {
            label: "微信",
            placeholder: "請輸入微信號",
          },
          line: {
            label: 'Line',
            placeholder: '請輸入Line帳號'
          },
          email: {
            label: "信箱",
            placeholder: "請輸入信箱",
            checkMessage: "請輸入正確的信箱",
          },
          useableCapacity: {
            label: "可用容量",
            placeholder: "請輸入可用容量",
            message: "請輸入可用容量",
          },
          distributionCapacity: {
            label: "分配的容量",
            placeholder: "請輸入分配的容量",
            message: "請輸入分配的容量",
            checkMessage: "分配容量不能大於可用容量",
          },
          distributionPoint: {
            label: "分配的點數",
            placeholder: "請輸入分配的點數",
            message: "請輸入分配的點數",
          }
        },
      },
    },
    user: {
      field: {
        dealer: {
          label: "經銷商",
          message: "請選擇經銷商",
        },
        store_type: {
          label: "所屬品牌",
          message: "請選擇所屬品牌",
        },
        store_id: {
          label: "店鋪編號",
          message: "請輸入店鋪編號",
        },
        nickname: {
          label: "暱稱",
          message: "請輸入暱稱",
        },
        linkman: {
          label: "聯繫人",
          message: "請輸入聯繫人",
        },
        type: {
          label: "用戶類型",
          message: "請選擇用戶類型",
        },
        childLimit: {
          label: "子帳號數量",
          message: "請輸入子帳號數量",
        },
        capacity: {
          label: "空間大小",
          message: "請分配空間大小",
        },
      },
    },
    pay: {
      payOnline: "在線付款",
      payCount: "付款金額",
      payFinish: "付款完成",
      field: {
        payType: {
          label: "付款方式",
          message: "請選擇付款方式",
          amountMsg: "金額超過49999，不能使用帳號匯款，請更改",
        },
      },
      paySure: "付款結果確認",
      paySureText: "請確認您的付款結果",
      payError: "付款遇到問題，請聯繫客服",
    },
    invoice: {
      label: "發票",
      invoiceType: "發票類型",
      head: {
        label: "發票抬頭",
        placeholder: '請填寫發票抬頭',
        message: "發票抬頭不能為空"
      },
      code: {
        label: "統一編碼",
        placeholder: '請填寫發票統一編碼',
        message: "統一編碼不能為空"
      },
      email: {
        label: "Email地址",
        placeholder: '請填寫電子發票寄送email的地址',
        message: "Email地址不能為空"
      },
      invoiceNo: "發票號碼",
      invoiceTime: "開票時間",
      invoicing: "開票",
      tipMsg: "您確定要開發票嗎？",
      information: "發票資訊",
      type: {
        1: "個人發票",
        2: "公司發票"
      },
      status: {
        0: "未開",
        1: "已開票"
      },
      tip: {
        0: "建議您使用Email寄送",
        1: "電子發票與實體發票具有相同效力，且可隨時上網查詢"
      }
    },
    team: {
      changeAccount: "切換帳號",
      personal: "個人",
      company: "公司",
      currUse: "當前使用",
      createTeam: "我創建的團隊",
      createMsg: "暫無創建的團隊",
      joinTeam: "我加入的團隊",
      joinMsg: "暫未有加入的團隊",
    },
    advertisement: {
      field: {
        name: {
          label: "廣告名稱",
          message: "請填寫廣告名稱",
          placeholder: "請填寫廣告名稱",
        },
        type: {
          label: "廣告類型",
          message: "請選擇廣告類型",
          placeholder: "請選擇廣告類型",
        },
        advertisement: {
          label: "廣告圖",
        },
      },
    },
    icon: {
      field: {
        name: {
          label: "圖標名稱",
          message: "請填寫圖標名稱",
          placeholder: "請填寫圖標名稱",
        },
        type: {
          label: "圖標類型",
          message: "請選擇圖標類型",
          placeholder: "請選擇圖標類型",
        },
        icon: {
          label: "上傳圖標",
        },
        thumb: {
          label: "上傳縮略圖",
        },
        cate: {
          label: "圖標分類",
          message: "請選擇圖標分類",
          placeholder: "請選擇圖標分類",
        }
      },
    },
    payConfig: {
      field: {
        name: {
          label: "規則名稱",
          message: "請填寫規則名稱",
          placeholder: "請填寫規則名稱",
        },
        amount: {
          label: "價格",
          message: "請填寫價格",
          placeholder: "請填寫價格",
          placeholderOne: "請填寫月數",
          placeholderTwo: "請填寫容量大小（單位G）",
        },
        num: {
          label: "數量",
          message: "請填寫數量",
          placeholder: "請填寫數量",
          placeholderOne: "請填寫月數",
          placeholderTwo: "請填寫容量大小（單位G）",
        },
        type: {
          label: "規則類型",
          message: "請選擇規則類型",
          placeholder: "請選擇規則類型",
        },
        description: {
          label: "詳細描述",
          message: "請輸入詳細描述",
          placeholder: "請輸入詳細描述",
        },
        payDescription: {
          label: "規則描述",
          message: "請輸入規則描述",
          placeholder: "請輸入規則描述",
        },
      },
    },
    receiving: {
      name: {
        label: "收件人",
        placeholder: "請輸入收件人的姓名",
        message: "收件人不能為空"
      },
      phone: {
        label: "聯繫手機",
        placeholder: "只接受手機",
        message: "聯繫手機不能為空"
      },
      address:
      {
        label: "收貨地址",
        placeholder: "請填寫完整的地址",
        message: "收貨地址不能為空"
      }
    },
    workUpgrade: {
      wname: {
        label: "作品名稱"
      },
      wname_upgrade: {
        label: "升級作品名稱",
      },
      status: {
        label: "上傳狀態",
        done: "已上傳",
        doing: "上傳中...請稍後...",
        fail: "上傳失敗，請再上傳一次",
        undo: "未上傳"
      },
      download:
      {
        label: "下載作品全景圖"
      },
      upload:
      {
        label: "上傳3D升級"
      }
    },
    project: {
      name: {
        label: "專案名稱",
        placeholder: "請輸入專案名稱"
      }
    }
  },
  table: {
    common: {
      thead: {
        gender: "性別",
        state: "狀態",
        wechat: "微信",
        email: "信箱",
        reviewer: "遊客",
        content: "內容",
        updateTime: "更新時間",
        expireTime: "過期時間",
        createTime: "創建時間",
        operate: "操作",
        publish: "最近發佈",
        recommend: "平台推薦",
        dealer: "經銷商",
        name: "作品名稱",
        status: "狀態",
        sort: "排序",
        materialName: "素材名稱",
      },
    },
    // material: {
    //   thead: {
    //     updateTime: "更新時間",
    //     operate: "操作",
    //   },
    // },
    tag: {
      thead: {
        tagId: "標籤ID",
        cate: "分類",
        name: "標籤名",
      }
    },
    user: {
      thead: {
        account: "用戶帳號",
        agent: "所屬經銷商",
        worksCount: "全景作品數",
        storage: "容量使用",
        panoConfigPower: "全景配置權",
        linkman: "聯繫人",
        accountType: "帳戶類型",
        nickname: "別名",
        superior: "所屬上級",
        area: "區域",
        loginTime: "登入時間",
        acountCount: "子帳戶數",
        childLimit: "子帳號限制",
      },
    },
    work: {
      thead: {
        readCount: "閱讀次數",
        userName: "發佈者",
        customerName: "客戶",
      },
    },
    materialAudit: {
      thead: {
        authorAlias: "提交人（別名）",
        fileSize: "文件大小",
        submissionTime: "提交時間",
      },
    },
    order: {
      thead: {
        user_name: "用戶帳號",
        order_sn: "訂單號碼",
        amount: "金額",
        create_time: "訂單生成時間",
        confirm_time: "付款時間",
        pay_type: "付款類型",
        order_subject: "訂單描述",
      },
    },
    advertisement: {
      thead: {
        id: "ID",
        name: "廣告名稱",
        type: "類型",
        size: "大小",
        status: "是否啟用",
      },
    },
    icon: {
      thead: {
        id: "ID",
        name: "圖標名稱",
        thumb: "縮略圖",
        type: "類別",
        // createTime: "創建時間"
      },
    },
    cate: {
      thead: {
        id: "分類ID",
        name: "分類名稱",
      },
    },
    article: {
      thead: {
        id: "ID",
        name: "名稱",
        type: "分類",
      },
    },
    payConfig: {
      thead: {
        id: "ID",
        name: "規則名稱",
        amount: "價格",
        num: "數量",
        type: "規則類型",
      },
    },
    customer: {
      thead: {
        placeholder: "請輸入客戶名稱",
        name: "客戶名稱",
        avatar: "頭貼",
        phone: "聯繫電話",
        lastTime: "近期通話紀錄",
        customerInfo: "詳細資料",
        download: "下載",
      }
    },
    project: {
      thead: {
        name: "專案名稱",
        cover: "專案封面",
        leader: "項目負責人",
        phone: "聯繫電話",
        progress: "當前進度"
      },
      type: {
        0: "個人專案",
        1: "團隊專案"
      }
    },
    team: {
      thead: {
        name: "團隊名稱",
        leader: "團隊管理員",
        workNum: "作品數量",
        viewNum: "瀏覽量",
        volume: "容量",
        members: "人數",
      },
      operate: {
        viewMember: "查看成員",
        dilatation: "擴容",
        volume: {
          label: "分配容量",
          placeholder: "請輸入團隊總容量",
          message: "團隊總容量不能為空"
        },
        member: {
          label: "分配人數",
          placeholder: "請輸入團隊總人數",
          message: "團隊總人數不能為空"
        }
      }
    },
    teamUser: {
      thead: {
        name: "暱稱",
        avatar: "頭貼",
        phone: "聯繫電話",
        admin: "管理員",
        createTime: "加入時間",
        position: "職位",
        line: "line",
        email: "信箱",
        addNew: "邀請新團隊成員",
        delMember: "刪除團隊成員",
      },
      info: {
        name: {
          label: "公司名稱",
          placeholder: "請輸入公司名稱",
          message: "公司名稱不能為空"
        },
        phone: {
          label: "聯繫電話",
          placeholder: "請輸入聯繫電話",
          message: "聯繫電話不能為空"
        },
        address: {
          label: "地址",
          placeholder: "請輸入地址",
          message: "地址不能為空"
        }
      }
    },
    contactUs: {
      thead: {
        id: "ID",
        name: "姓名",
        phone: "電話",
        industry: "行業",
        status: "是否處理",
        create_time: "提交時間"
      },
    },
  },
  member: {
    membership: "會員等級",
    total: "總價",
    num: "數量",
    iconTop: "圖示上層文字",
    iconBottom: "圖示下層文字",
    ruleDescription: "規則描述",
    cameraType: "相機類型",
    modifMemberD: "修改會員介紹",
    question: "問題",
    answer: "答案",
    name: "名稱",
    introduce: "簡介",
    icon: "圖示",
    chooseImg: "選擇圖片",
    detailImg: "圖片詳情",
    memberDetail: "會員詳情",
    isiNstalment: "是否分期",
    yes: "是",
    no: "否",
    installment: "分期付款",
    serialNumber: "編號",
    paymentType: "付款類別",
    paymentInstallment: "付款分期",
    PercentageIncreasePlatform: "平台增收百分比",
    pleaseEnterValue: "請輸入數值，如2.10",
    presentMouth: "贈送月份",
    totalErr: "請輸入總價",
    numErr: "請輸入數量",
    presentMouthErr: "請輸入贈送月份",
    iconTopErr: "請輸入圖示上層文字",
    iconBottomErr: "請輸入圖示下層文字",
    ruleDescriptionErr: "請輸入規則描述",
    editeSuccse: "編輯成功",
    answerErr: "請輸入問題",
    questionErr: "請輸入答案",
    introduceErr: "請出入簡介",
    nameErr: "請輸入名稱",
    ruleName: "名稱",
    ruleNameErr: "請輸入名稱",
    selectLevelText: "選擇會員等級",
    memberText: "會員",
    isTeamId: "是否是黑鑽企業會員",
    teamText: "團隊",
    monthly: "每月",
    specials: "特價",
    amountUnit: "元",
    NT: "NT",
    NT$: "NT$",
    year: "年",
    upgradeBtn: "升級",
    buyBtn: "購買",
    addBtn: "加值",
    payment: "支付",
    changePackage: "另選套餐",
    step: {
      0: "選擇支付方式",
      1: "填寫發票資訊",
      2: "支付"
    },
    numOver: "數量不能小於1",
  },
  enum: {
    covers: {
      0: "作品封面",
      1: "封面圖",
      2: "PC端封面",
      3: "手機端封面",
      4: "開場封面",
    },
    switch: {
      0: "關",
      1: "開",
    },
    gender: {
      male: "男",
      female: "女",
    },
    workIsPublic: {
      1: "公開",
      0: "不公開",
    },
    userStatus: {
      0: "註銷",
      1: "正常",
    },
    expireStatus: {
      0: "正常",
      1: "到期",
    },
    userOther: {
      overdue: "過期",
      create: "創建",
    },
    userType: {
      1: "管理員",
      2: "經銷商",
      3: "普通用戶",
      4: "員工用戶"
    },
    userLevel: {
      0: '免費用戶',
      1: '普通會員',
      2: '黃金VIP會員',
      3: '黑鑽VIP企業會員'
    },
    materialAuditStatus: {
      0: "待審",
      1: "通過",
      2: "駁回",
    },
    tagType: {
      0: "全景圖片",
      1: "全景影片",
      2: "全景直播",
    },
    authority: {
      0: "關閉",
      1: "打開",
    },
    payType: {
      alipay: "支付寶",
      wxpay: "微信",
      offline: "線下支付",
      ecpay: "綠界刷卡",
      point: '點數兌換'
    },
    payStatus: {
      0: "待處理",
      1: "成功",
      2: "失敗",
    },
    advStatus: {
      0: "禁用",
      1: "啟用",
    },
    advType: {
      0: "頂部廣告",
      1: "中部廣告",
    },
    iconType: {
      0: "靜態",
      1: "動態",
    },
    iconCate: {
      1: "熱點圖標",
      2: "漫遊圖標",
    },
    payConfigType: {
      1: "續費",
      2: "增加容量",
      3: "擴充人數",
      4: "升級解鎖",
      5: "套餐方案",
      6: "加購相機",
      7: "購買數量"
    },
    materialType: {
      0: "全景圖片",
      1: "圖片",
      2: "音樂",
      3: "影片",
      4: "全景影片",
      5: "全景直播"
    },
    store_type: {
      0: '請選擇品牌',
      1: '大家房屋',
      2: '住商不動產'
    },
    modelOther: {
      points: '剩餘點數:'
    }
  },
  updateModel  : {
    updateHouse: "3D升級",
    rules: '3D模型屋 拍攝規範',
    slogan: '場景過到需串接 門不能關 需有重疊部分',
    sloganDesc: '建議相隔1m拍攝一次 過到最好有拍攝',
  },
  copyModel: {
    title: "複製作品",
    workName: '作品名稱',
    slogan: '該作品的當前空間資訊、基本設定、點設定、熱點、參考線、調整、平面圖和模型修剪將被複製',
    sloganDesc: '注意：當目前作品有多個副本時，原始資料無法修改。您確定複製目前空間嗎？',
    capacityInsufficient: '個人容量不夠',
    capacityInsufficientRemark: '請清理個人空間容量',
    success: '複製成功',
  },
  upgradeInfo: {
    altogether: '此物件共有',
    panorama: '張全景圖',
    modelHouse: '模型屋',
    severalGroup: '組',
    addPurchase: '需加購',
    severalPicture: '張',
    houseInfo: '(模型屋一組: 20點最多20張，超出數量需加購: 1點一張)',
    housePoint: '點',
    total: '合計',
    read: '我已閱讀完拍攝規範'
  },
  alertMessage: {
    purchaseSuccess: '3D模型屋以購買成功',
    workingDays: '(3D模型屋需要2~3天的工作天)',
    confirm: '確認',
    balance: '餘額不足',
    currently: '目前僅有:',
    point: '點',
    lack: '您尚缺:',
    topUp: '馬上儲值'
  },
  upgradeNotify: {
    notify: '您的3D模型屋升級',
    updated: '已更新'
  },
  returnNotify: {
    notify: '3D模型屋退件通知',
    yourHouse: '你的3D模型屋',
    incompatible: '不符合規範',
    contact: '若有問題請歡迎與我們聯繫, 我們將有專員為您處理',
    projectName: '作品名稱:',
    confirm: '確認',

  }
};

export default tw;
